<!-- El aviso de un módulo en mantenimiento (16/10/2026). -->
<div class="main-content mm-aviso">
  @if (!cargando()) {
    @if (modulo(); as m) {
      <section class="mm-aviso__tarjeta" aria-labelledby="mmAvisoTitulo">
        <span class="mm-aviso__icono" aria-hidden="true">
          <span class="material-icons">construction</span>
        </span>
        <p class="mm-aviso__etiqueta">En mantenimiento</p>
        <h1 id="mmAvisoTitulo" class="mm-aviso__titulo">{{ m.nombre }}</h1>
        <p class="mm-aviso__mensaje">{{ mensaje() }}</p>
        @if (cuando()) {
          <p class="mm-aviso__cuando">
            <span class="material-icons" aria-hidden="true">event_available</span>
            Vuelve a estar disponible {{ cuando() }}.
          </p>
        }
        <div class="mm-aviso__acciones">
          <button type="button" class="app-form-btn app-form-btn--secondary" (click)="regresar()">Regresar</button>
          <a class="app-form-btn app-form-btn--primary" routerLink="/dashboard">Ir al inicio</a>
        </div>
      </section>
    } @else {
      <section class="mm-aviso__tarjeta mm-aviso__tarjeta--lista" aria-labelledby="mmAvisoListo">
        <span class="mm-aviso__icono" aria-hidden="true">
          <span class="material-icons">task_alt</span>
        </span>
        <h1 id="mmAvisoListo" class="mm-aviso__titulo">Ya está disponible</h1>
        <p class="mm-aviso__mensaje">Este módulo ya no está en mantenimiento. Puedes volver a entrar.</p>
        <div class="mm-aviso__acciones">
          <button type="button" class="app-form-btn app-form-btn--secondary" (click)="regresar()">Regresar</button>
          <a class="app-form-btn app-form-btn--primary" routerLink="/dashboard">Ir al inicio</a>
        </div>
      </section>
    }
  }
</div>
